(function AIAccessories() {
  'use strict';

  var config = JSON.parse(document.querySelector('[data-ai-related]').innerHTML);
  var section = document.querySelector('[data-product-accessories]');
  var product = { id: config.id };
  var markup = [];

  getLevelOne(product).then(getLevelTwo).then(function(products){
    var productsUnique = uniqueBy(products, 'handle').filter(available).filter(disallowed);
    var productsMarkup = productsUnique.map(getProductMarkup);

    when(productsMarkup).done(function(markup) {
      var sorted = sortByScore(markup);
      append(pluck(sorted, 'response'));

      section.removeAttribute('hidden');
      reInitSlider();

    });
  })

  function reInitSlider() {
    if (POV.Slider) {
      var slider = POV.Slider.find(function(slider) {
        return slider.id === 'product-accesories';
      });

      if (slider) slider.reinit();
    }
  }

  /**
   * Get main product related recommendations
   * @param {Object} product Object containing product ID
   * @return {Promise} Returns Shopify recommendations promise list
   */
  function getLevelOne(product) {
    var level = 1;
    return apiCall(level, product);
  }

  /**
   * Get secondary related product recommendations
   * @param {Array} levelOneProducts List of recommendations
   * @return {Promise} Returns Shopify recommendations promise list
   */
  function getLevelTwo(levelOneProducts) {
    var defer = $.Deferred();

    if (!levelOneProducts.length) {
      defer.reject();
      return defer;
    }

    var level = 2;
    var getRelatedProduct = partial(apiCall, level);
    var getRelatedProducts = levelOneProducts.map(getRelatedProduct);

    when(getRelatedProducts).done(function(levelTwoProducts) {
      defer.resolve(levelOneProducts.concat(levelTwoProducts));
    });

    return defer;
  }

  /**
   * Shopify recommendations API call
   * @param {Number} level Relevance level
   * @param {Object} product Object containing product handle
   * @return {Promise} Returns Shopify recommendations promise list filtered by matching type and tag
   */
  function apiCall(level, product) {
    var defer = $.Deferred();

    $.getJSON('/recommendations/products.json?product_id=' + product.id + '&limit=10', function(response) {
      var score = partial(setScore, level);
      var filteredProducts = response.products.map(score).filter(filterType).filter(filterTag);

      defer.resolve(filteredProducts);
    })

    return defer;
  }

  /**
   * Get product markup
   * @param {Object} product Object containing product data
   * @return {Promise} Returns product markup and relevance score level
   */
  function getProductMarkup(product) {
    var defer = $.Deferred();
    var url = [config.store, '/products/', product.handle, '?view=accessory'].join('');

    $.get(url, function(response) {
      markup.push({response: response, score: product.score});
      defer.resolve(markup);
    })    

    return defer;
  }

  /**
   * Append products markup to accessories slider
   * @param {Array} markup List containing product recommendations markup
   * @return {Array} markup List containing product recommendations markup
   */
  function append(markup) {
    return markup.map(function(item) {
      var $item = $(item);
      var picture = $item.find('picture')[0];

      $('[data-product-accessories] [data-slider-track]').append($item);
      POV.LazyPicture.init(picture);
    });
  }

  /**
   * jQuery Promise util
   * @param {Array} arr List of promises
   * @return {function} jQuery .when function with applied deferred
   */
  function when(arr){
    return $.when.apply(this, arr);
  }

  /**
   * Add relevance score to product data
   * Products directly returned from Shopify API will have a score of 10
   * Products returned from subsequent API calls will have a score equal to matching tags
   * @param {Number} level Relevance level
   * @param {Object} product Object containing product data
   * @return {function} Object containing product data and relevance score
   */
  function setScore(level, product) {
    product.score = (level === 1) ? 10 : tagMatch(product);
    return product;
  }

  /**
   * Filter util
   * @param {Object} product Product object
   * @return {Number} Returns a matching number of product tags
   */
  function tagMatch(product) {
    return config.tags.filter(function (value) {
      return includes(product.tags, value);
    }).length;
  }

  /**
   * Filter util
   * @param {Object} product Product object
   * @return {Boolean} Returns whether the provided product is of type
   */
  function filterType(product) {
    return product.type === 'Parts & Accessories';
  }

  /**
   * Filter util
   * @param {Object} product Product object
   * @return {Boolean} Returns whether the provided product contains some tags
   */
  function filterTag(product) {
    return product.tags.some(function(item) {
      return includes(config.tags, item);
    });
  }

  /**
   * Filter util
   * @param {Object} product Product object
   * @return {Boolean} Returns whether the provided product is available
   */
  function available(product) {
    return product.available;
  }

  /**
   * Filter util
   * @param {Object} product Product object
   * @return {Boolean} Returns whether the provided product is not disallowed
   */
  function disallowed(product) {
    return not(includes(config.disallowed, product.handle));
  }
    
  /**
   * Returns a new list containing only one copy of each element in the original
   * list, based upon the propriety provided
   * @param {Array} arr The array to consider
   * @param {String} prop The array item propriety to match uppon
   * @return {Array} The list of unique items.
   */
  function uniqueBy(arr, prop) {
    var found = [];

    return arr.reduce(function(acc, cur) {
      var lookFor = cur[prop];
      if (not(includes(found, lookFor))) acc.push(cur);
    
      found.push(lookFor);
      return acc;
    }, []);
  }

  /**
   * Array util
   * @param {Array} arr The array to consider
   * @return {Array} The list sorted by score.
   */
  function sortByScore(arr) {
    return arr.sort(function(a, b) {
      return b.score - a.score;
    });
  }

  /**
   * Returns true if the specified value is in provided array.
   * @param {Array} arr The array to consider.
   * @param {Array} val The item to compare against.
   * @example
   *   includes([1,2], 1) => true;
   * @return {Boolean} Returns whether the equivalent item is in the list
   */
  function includes(arr, val) {
    return (arr.indexOf(val) > -1);
  }

  /**
   * A function that returns the '!'' of its argument
   * @param {Boolean} boolean argument
   * @example
   *   not(0) => true
   * @return {Boolean} the logical inverse of passed argument
   */
  function not(boolean) {
    return !boolean;
  }

  /**
   * Returns a new list by plucking the same named property off all objects in the list supplied
   * @param {Array} arr to look into
   * @param {String} key to look for
   * @example
   *   var arr = [{name:'Daniel'}, {name:'Tomas'}];
   *   pluck(arr, 'name') => ['Daniel','Tomas'];
   * @return {Array} with found key values
   */
  function pluck(arr, key) {
    return arr.map(function(obj) {
      return obj[key];
    });
  }

  /**
   * Partial appliction.
   * Takes a function f and a list of arguments, and returns a function g with arguments applied
   * @param {function} fn The provided function
   * @example
   *   function sum(a,b) {return a + b};
   *   var add10 = partial(sum, 10);
   *   [1,2,3].map(add10) => [11,12,13];
   * @return {Function} Function with applyed arguments
   */
  function partial(fn) {
    var slice = Array.prototype.slice;
    var args = slice.call(arguments, 1);
    return function() {
      return fn.apply(this, args.concat(slice.call(arguments, 0)));
    };
  }
  
})();